var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0049 0.50293C14.1488 0.517165 14.2845 0.58139 14.3877 0.68457L19.3154 5.6123L19.3574 5.6582C19.4491 5.77005 19.5 5.91173 19.5 6.05762V16.9004C19.4999 17.5898 19.2268 18.2517 18.7393 18.7393C18.2517 19.2268 17.5898 19.4999 16.9004 19.5H3.09961C2.41016 19.4999 1.74826 19.2268 1.26074 18.7393C0.773226 18.2517 0.500077 17.5898 0.5 16.9004V3.09961C0.500077 2.41017 0.773226 1.74826 1.26074 1.26074C1.74826 0.773226 2.41017 0.500077 3.09961 0.5H13.9424L14.0049 0.50293ZM3.09961 1.75586C2.7435 1.75594 2.40123 1.8976 2.14941 2.14941C1.8976 2.40123 1.75594 2.7435 1.75586 3.09961V16.9004C1.75594 17.2565 1.8976 17.5988 2.14941 17.8506C2.40123 18.1024 2.7435 18.2441 3.09961 18.2441H4.44238V10.9854C4.4426 10.6386 4.72447 10.3576 5.07129 10.3574H14.9287C15.2755 10.3576 15.5574 10.6386 15.5576 10.9854V18.2441H16.9004C17.2565 18.2441 17.5988 18.1024 17.8506 17.8506C18.1024 17.5988 18.2441 17.2565 18.2441 16.9004V6.31738L13.6826 1.75586H5.7002V5.42871H12.957C13.3041 5.42871 13.585 5.71055 13.585 6.05762C13.5846 6.40438 13.3039 6.68555 12.957 6.68555H5.07129C4.72455 6.68542 4.44274 6.4043 4.44238 6.05762V1.75586H3.09961ZM5.7002 18.2441H14.2998V11.6143H5.7002V18.2441Z",
    fill: "#00BDD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.5d60d7d3cde99d5ea8a5d473530ab3c6.svg";
export { ForwardRef as ReactComponent };